module.exports = __webpack_public_path__ + "static/media/05.Foreign tour.b287cd27.JPG";